export const UNIT_MAX_LENGTH = 12;
